import React, { ReactElement } from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import classNames from 'classnames';

import styles from './YMap.module.scss';
import { IMapPosition } from "@common/redux/types/common";
import { useYandexTermsLinks } from "@common/hooks/useYandexTermsLinks";

interface IProps {
  mapPosition: IMapPosition,
  placeName: string,
  classes?: string,
  iconImageHref?: string,
  iconImageHrefHovered?: string,
  iconImageSize?: [number, number],
  iconOffset?: [number, number],
}

export const YMap = ({
  mapPosition,
  placeName,
  classes,
  iconImageHref,
  iconImageHrefHovered,
  iconImageSize,
  iconOffset,
}: IProps): ReactElement => {
  useYandexTermsLinks();

  if (!mapPosition) {
    return (<></>);
  }

  const { coordinates } = mapPosition;

  return (
    <YMaps>
      <Map
        state={{
          center: coordinates,
          zoom: 15,
        }}
        options={{ suppressMapOpenBlock: true }}
        className={classNames([styles.map, classes && classes])}
      >
        <Placemark
          geometry={coordinates}
          properties={{
            hintContent: placeName || ''
          }}
          options={{
            iconLayout: 'default#image',
            iconImageHref: iconImageHref ? iconImageHref : undefined,
            iconImageHrefHovered: iconImageHrefHovered ? iconImageHrefHovered : undefined,
            iconImageSize: iconImageSize ? iconImageSize : [38, 52],
            iconOffset: iconOffset ? iconOffset : [-2, -13],
          }}
          modules={
            ['geoObject.addon.balloon', 'geoObject.addon.hint']
          }
        />
      </Map>
    </YMaps>
  );
};
